import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';

const FLAG_WIDTH = 52;
const FLAG_HEIGHT = 52;
const POLE_WIDTH = 5;
const POLE_HEIGHT = 40;

export const FLAG_CANVAS_WIDTH = FLAG_WIDTH;
export const FLAG_CANVAS_HEIGHT = FLAG_HEIGHT + POLE_HEIGHT;
const FLAG_LEFT = 0;
const FLAG_TOP = 2;
const FLAG_RIGHT = FLAG_LEFT + FLAG_WIDTH;
const FLAG_BOTTOM = FLAG_TOP + FLAG_HEIGHT;
const POLE_X = FLAG_LEFT;
const POLE_Y = FLAG_BOTTOM;

// Bottom-left triangle + pole
export const createFlagBottomAtlas = (): string => {
  const res = createCanvas(FLAG_CANVAS_WIDTH, FLAG_CANVAS_HEIGHT);

  if (!res?.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  ctx.fillStyle = '#FFFFFF';

  ctx.beginPath();
  ctx.moveTo(FLAG_LEFT, FLAG_TOP);
  ctx.lineTo(FLAG_LEFT, FLAG_BOTTOM);
  ctx.lineTo(FLAG_RIGHT, FLAG_BOTTOM);
  ctx.closePath();
  ctx.fill();

  ctx.fillRect(POLE_X, POLE_Y, POLE_WIDTH, POLE_HEIGHT);

  return canvas.toDataURL();
};

// Top-right triangle
export const createFlagTopAtlas = (): string => {
  const res = createCanvas(FLAG_CANVAS_WIDTH, FLAG_CANVAS_HEIGHT);

  if (!res?.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  ctx.fillStyle = '#FFFFFF';

  ctx.beginPath();
  ctx.moveTo(FLAG_LEFT, FLAG_TOP);
  ctx.lineTo(FLAG_RIGHT, FLAG_TOP);
  ctx.lineTo(FLAG_RIGHT, FLAG_BOTTOM);
  ctx.closePath();
  ctx.fill();

  return canvas.toDataURL();
};
